import React from 'react';
import { RouterProvider } from 'react-router-dom';
import { FilterProvider } from 'contexts/filter';
import { ErrorProvider } from 'contexts/error';
import { InfoProvider } from 'contexts/info';
import { SpaceProvider } from 'contexts/space';
import { ThemeProvider } from '@mui/material/styles';
import { ModalProvider } from 'contexts/modal';
import { StyledEngineProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import IntlWrapper from 'components/wrappers/intl';
import ApolloWrapper from 'components/wrappers/apollo';
import theme from 'theme';
import useLocale from 'hooks/use_locale';
import router from 'routes';

const App = () => {
  const locale = useLocale();

  return (
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <IntlWrapper locale={locale}>
          <ApolloWrapper apiUrl={import.meta.env.VITE_GRAPHQL_SERVER_URL}>
            <SpaceProvider>
              <FilterProvider>
                <ErrorProvider>
                  <InfoProvider>
                    <ModalProvider>
                      <RouterProvider router={router} />
                    </ModalProvider>
                  </InfoProvider>
                </ErrorProvider>
              </FilterProvider>
            </SpaceProvider>
          </ApolloWrapper>
        </IntlWrapper>
      </ThemeProvider>
    </StyledEngineProvider>
  );
};

export default App;
